import React from 'react';
import Header from './Header';
import Footer from './Footer';
import './XLjoin.css';
import { hrMail } from '../App';

const XLjoin: React.FC = () => {
  return (
    <div className="xl-join-container">
      <Header />

      <section className="xl-join-hero">
        <div className="xl-hero-inner">
          <h1 className="xl-hero-title">欢迎来到我们的AI世界</h1>
          <p className="xl-hero-text">
            我们致力于通过AI能力驱动行业落地，帮助企业提升服务效率与用户体验。加入我们，一起探索AI的无限可能。
          </p>
        </div>
      </section>

      <section className="xl-join-reasons">
        <div className="xl-reasons-inner">
          <h2 className="xl-reasons-title">选择我们的理由</h2>
          <p className="xl-reasons-text">
            公司由十年以上行业经验或从事人工智能领域研究的资深人士领导，能够为公司提供正确的发展方向和切实可行的发展路径。同时也为大家提供了舒适的发展路径和舒适的工作环境。
          </p>
        </div>
      </section>

      <section className="xl-join-positions">
        <div className="xl-positions-inner">
          <p className="xl-positions-subtitle">欢迎加入我们</p>
          <h2 className="xl-positions-title">当前开放职位</h2>
          <p className="xl-positions-desc">
            在这里你可以浏览我们正在招聘的岗位，我们欢迎有专业才华的你加入我们的团队，共同创造卓越的服务体验。
          </p>

          <div className="xl-job-list">
            {/* Job 1 */}
            <div className="xl-job-item">
              <div className="xl-job-header">
                <h3 className="xl-job-name">开发工程师</h3>
                <span className="xl-job-dept">研发部门</span>
              </div>
              <p className="xl-job-desc">
                熟悉并掌握业务相关的编码开发能力和扩展开发能力，熟悉并适应团队开发带来的从熟悉到开发，逐渐将需求落实到开发任务的机会，助力您进一步发展。
              </p>
              <div className="xl-job-footer">
                <span className="xl-job-location">📍 杭州滨江</span>
                <a href={`mailto:${hrMail}`} className="xl-job-apply">立即申请</a>
              </div>
            </div>

            <div className="xl-job-item">
              <div className="xl-job-header">
                <h3 className="xl-job-name">产品经理</h3>
                <span className="xl-job-dept">研发部门</span>
              </div>
              <p className="xl-job-desc">
                欢迎卓越的产品经理，为我们新客户提供卓越的支持。加入我们的团队，您将参与制定产品工作计划，负责产品开发和优化。
              </p>
              <div className="xl-job-footer">
                <span className="xl-job-location">📍 杭州滨江</span>
                <a href={`mailto:${hrMail}`} className="xl-job-apply">立即申请</a>
              </div>
            </div>

            <div className="xl-job-item">
              <div className="xl-job-header">
                <h3 className="xl-job-name">业务运营</h3>
                <span className="xl-job-dept">业务部门</span>
              </div>
              <p className="xl-job-desc">
                我们寻找具有丰富行业经验的业务同学，主要负责客服和医疗领域。如果您熟悉相关的工具，熟悉行业现状，这里将是您实现梦想的最佳平台。
              </p>
              <div className="xl-job-footer">
                <span className="xl-job-location">📍 杭州滨江</span>
                <a href={`mailto:${hrMail}`} className="xl-job-apply">立即申请</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="xl-join-cta">
        <div className="xl-cta-inner">
          <h2 className="xl-cta-title">立即申请，开启您的职场新旅程</h2>
          <div className="xl-cta-contact">
            <p className="xl-cta-text">{`可以立即发送邮件联系我们：${hrMail}`}</p>
            <a href={`mailto:${hrMail}`} className="xl-cta-btn">立即申请</a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default XLjoin;